import { render } from "./PaginationComponent.vue?vue&type=template&id=fd08d0e8"
import script from "./PaginationComponent.vue?vue&type=script&lang=js"
export * from "./PaginationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/PaginationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd08d0e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd08d0e8', __exports__)) {
    api.reload('fd08d0e8', __exports__)
  }
  
  module.hot.accept("./PaginationComponent.vue?vue&type=template&id=fd08d0e8", () => {
    api.rerender('fd08d0e8', render)
  })

}


export default __exports__